<button class="follow-btn" [disabled]="isLoading || isFollowed" (click)="openPopup(loginPopup)" mat-button>
  <div *ngIf="!isFollowed && !isLoading" class="follow-icon">
    <i class="material-icons">add_circle_outline</i>
    <span>Follow Campaign</span>
  </div>
  <div *ngIf="isFollowed && !isLoading" class="follow-icon">
    <i class="material-icons">check_circle_outline</i>
    <span>Following</span>
  </div>
  <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
</button>


<ng-template #loginPopup>
  <div class="follow-form">
    <app-close-btn top="0px" right="0px" [type]="type"></app-close-btn>
    <div *ngIf="step === 'step_1'" class="header">
      <div class="header-img">
        <img data-src="/assets/images/donation-confirmation-img.png" alt="">
      </div>

      <div class="title">
        Follow <strong>{{fundraiser?.beneficiaryname?.info_1}}'s</strong> campaign!
      </div>

      <div class="sub-title">
        Don't miss out on any updates related to this campaign
      </div>
    </div>

    <form [hidden]="!(step === 'step_1')" class="login-screen" [formGroup]="loginForm" (ngSubmit)="submitForm()">
      <app-input inputType="text"
                [control]="loginForm.get('name')"
                [group]="loginForm"
                [placeHolder]="'Stories.donations.name.placeholder' | translatePipe | async"
                [fieldRequired]="'Stories.bankTransfer.requiredField' | translatePipe | async"
                icon="icon-user"
                [label]="'Stories.donations.name.placeholder' | translatePipe | async"
                [errorMessage]="'Stories.donations.name.error' | translatePipe | async">
      </app-input>
      <app-input inputType="email"
                [control]="loginForm.get('email')"
                [group]="loginForm"
                [placeHolder]="'Stories.donations.email.placeholder' | translatePipe | async"
                [label]="'Stories.donations.email.placeholder' | translatePipe | async"
                [fieldRequired]="'Stories.bankTransfer.requiredField' | translatePipe | async"
                icon="icon-mail"
                [errorMessage]="'Stories.donations.email.error' | translatePipe | async">
      </app-input>
      <app-intl-input [control]="loginForm.get('mobile')" [group]="loginForm" (numberEmit)="number=$event"
                      [placeholder]="'Stories.donations.phone' | translatePipe | async"
                      [label]="'Stories.donations.phone' | translatePipe | async"
                      [validNoErr]="'Stories.donations.enterValidPhone' | translatePipe | async">
      </app-intl-input>
      <app-captcha-input [control]="loginForm.get('captcha')" type="dialog" size="invisible" #captchaRef></app-captcha-input>
      <button class="submit-btn" color="primary" type="submit" [disabled]="isLoading" mat-flat-button>
        <span *ngIf="!isLoading">Follow Now</span>
        <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </button>
    </form>

    <div *ngIf="step === 'step_2'" class="otp-screen">
      <app-module-loader moduleId="otp-confirmation" selector="app-otp-confirmation"
                        [load]="true"
                        [inputs]="{type: 'onpage', user: payload, disableGoogleLogin: util.detectBrowser() === 'Safari' ? true : false}"
                        [outputs]="{ verified: getVerifiedToken, verifiedUser: getVerifiedUser }">
      </app-module-loader>
    </div>
  </div>

</ng-template>